import { Routes } from '@angular/router';
import { AttendanceService } from '~/routes/_/attendance/attendance.service';
import { EmployeesService } from '~/routes/_/employees/employees.service';
import { SettingsService } from '~/routes/_/settings/settings.service';
import { AuthService } from '~/routes/auth/auth.service';

export const appRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('~/routes/_/container.component').then(m => m.ContainerComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'attendance',
      },
      {
        path: 'attendance',
        providers: [AttendanceService],
        loadChildren: () => import('~/routes/_/attendance/attendance.routes').then(m => m.attendanceRoutes),
      },
      {
        path: 'employees',
        providers: [EmployeesService],
        loadChildren: () => import('~/routes/_/employees/employees.routes').then(m => m.employeesRoutes),
      },
      {
        path: 'settings',
        providers: [SettingsService],
        loadComponent: () => import('~/routes/_/settings/settings.component').then(m => m.SettingsComponent),
      },
    ],
  },
  {
    path: 'auth',
    providers: [AuthService],
    loadChildren: () => import('~/routes/auth/auth.routes').then(m => m.authRoutes),
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'attendance',
  },
];
